/**
 * Cognito UserPool の passwordPolicy と同じ要件をクライアント側で検証する。
 * 参照: infra/portal/cdk/lib/auth/stacks/common-auth-stack.ts (passwordPolicy)
 */

export const PASSWORD_REQUIREMENTS_TEXT =
  "英大文字を含む8文字以上の英数字記号で設定してください。安全のため、他のサイトと同じパスワードの使用は避けてください。";

const PASSWORD_REQUIREMENTS_ERROR =
  "パスワードは英大文字を含む8文字以上の英数字記号で設定してください。";

const MIN_PASSWORD_LENGTH = 8;
const SYMBOL_REGEX = /[!-/:-@[-`{-~]/;

/**
 * パスワードが Cognito ポリシーを満たすか検証する。
 * 失敗時は要件説明の単一メッセージを返し、成功時は null を返す。
 */
export function validatePasswordRequirements(password: string): string | null {
  const meetsRequirements =
    password.length >= MIN_PASSWORD_LENGTH &&
    /[A-Z]/.test(password) &&
    /[a-z]/.test(password) &&
    /[0-9]/.test(password) &&
    SYMBOL_REGEX.test(password);
  return meetsRequirements ? null : PASSWORD_REQUIREMENTS_ERROR;
}
